import './colorPicker.scss';

import React, { FunctionComponent } from 'react';

import classNames from 'classnames';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  label: string;
  name: string;
  id: string;
  displayHeadingToRight?: boolean;
  disabled?: boolean;
  defaultColour?: string;
};

const ColorPicker: FunctionComponent<Props> = ({
  label,
  name,
  id,
  displayHeadingToRight = false,
  disabled = false,
  defaultColour,
}) => {
  const { t } = useTranslation();
  const { register, setValue } = useFormContext();
  const watchedSelectedColour = useWatch({ name });

  const selectedColor =
    disabled && defaultColour ? defaultColour : watchedSelectedColour;

  return (
    <fieldset className="jg-form-group">
      <div
        className={classNames(
          'colorPicker__headingWrapper',
          { colorPicker__headingWrapper__right: displayHeadingToRight },
          { colorPicker__headingWrapper__above: !displayHeadingToRight },
        )}
      >
        <div
          className={classNames('jg-form-label jg-color--nero', {
            colorPicker__heading__right: displayHeadingToRight,
          })}
        >
          {label}
        </div>
        <div className="colorPicker">
          <div
            className="colorPicker__selectedColor"
            style={{ backgroundColor: selectedColor }}
          ></div>
          <input
            type="color"
            className="colorPicker__inputColor"
            id={id}
            aria-label={`${t('colourPicker.colourPickerfor')} ${label}`}
            disabled={disabled}
            {...register(name, {
              onChange: (e) => setValue(`${name}_text`, e.target.value),
            })}
          />
          <input
            className="colorPicker__inputText"
            type="text"
            value={selectedColor}
            aria-label={`${t('colourPicker.hexCodeFor')} ${label}`}
            disabled={disabled}
            {...register(`${name}_text`, {
              onChange: (e) => setValue(name, e.target.value),
            })}
          />
        </div>
      </div>
      <label
        htmlFor={id}
        className={disabled ? 'colorPicker__labelDisabled' : 'jg-text--link'}
        aria-hidden
      >
        {t('colourPicker.useColorPicker')}
      </label>
    </fieldset>
  );
};

export default ColorPicker;
